import { render, staticRenderFns } from "./CotationsView.vue?vue&type=template&id=c01fb306&scoped=true&"
import script from "./CotationsView.vue?vue&type=script&lang=js&"
export * from "./CotationsView.vue?vue&type=script&lang=js&"
import style0 from "./CotationsView.vue?vue&type=style&index=0&id=c01fb306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01fb306",
  null
  
)

export default component.exports